import { useSelector } from "react-redux";
import { selectSavedAffiliate } from "~/domains/affiliate/redux/selectors";

export function usePreferredSalesPartner() {
  return useSelector(selectSavedAffiliate);
}
